import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import TextField from '@material-ui/core/TextField';
import Determination_Switches from './Determination-switch';
import PressureCorrection from './PressureCorrection';
import { QuantityDeterminationService } from '../../services/bunkermaster/QuantityDeterminationService';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(Parameter, Unit, Fuel1, Fuel2, Target, Blend) {
    return { Parameter, Unit, Fuel1, Fuel2, Target, Blend };
}

const rows = [
    createData('.', '.', '.', '.', '.', '.', '.', '.', '.', '.'),
    createData('.', '.', '.', '.', '.', '.', '.', '.', '.', '.'),
    createData('.', '.', '.', '.', '.', '.', '.', '.', '.', '.'),
    createData('.', '.', '.', '.', '.', '.', '.', '.', '.', '.'),
    createData('.', '.', '.', '.', '.', '.', '.', '.', '.', '.'),
    createData('.', '.', '.', '.', '.', '.', '.', '.', '.', '.'),
];



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function QuantityDetermination() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [add, setAdd] = React.useState({ volume: "", weight: "" });
    const [fieldClass, setFieldClass] = React.useState(true);
    const [disableInput, setDisableInput] = React.useState(false);
    const [Asclose, setAsclose] = React.useState();
    const [close, setClose] = React.useState(true);
    const [close1, setClose1] = React.useState(true);
    const [gridData, setGridData] = React.useState([]);
    const [validateField, setValidateField] = React.useState({ msg: "", textstyle: "userinfo" })
    const [validateFieldClass, setValidateFieldClass] = React.useState({ ObservedGravityValue: true, ObservedGravityTemperature: true, ObservedQuantityValue: true, ObservedQuantityTemperature: true, BaseTemperatureValue: true })
    const [error, setError] = React.useState({ errormsg: "", style: "" })

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const [order, setOrder] = React.useState({
        CorrectedVolumeTextBox: "",
        VCFTextbox: "",
        WCFTextBox: "",
        WeightTextBox: "",
        MassLabel: "",
    });
    const [QuantityDetermination, setQuantityDetermination] = React.useState({
        Commodity: 2,

        ObservedGravityType: 1,
        ObservedGravityValue: "",
        ObservedGravityTemperature: "15",
        ObservedGravityTemperatureUnit: 1,
        ObservedGravityPressure: 0,
        ObservedGravityPressureUnit: 1,

        ObservedQuantityUnit: 1,
        ObservedQuantityValue: "",
        ObservedQuantityTemperature: "",
        ObservedQuantityTemperatureUnit: 1,
        ObservedQuantityPressure: 0,
        ObservedQuantityPressureUnit: 1,

        BaseTemperatureValue: "15",
        BaseTemperatureUnit: "1",
        BasePressureValue: "0",
        BasePressureUnit: "1",
    });
    const CalculateQuantityDetermination = () => {
        ;

        if (QuantityDetermination["ObservedGravityValue"] === "" || QuantityDetermination["ObservedGravityTemperature"] === "" || QuantityDetermination["ObservedQuantityTemperature"] === "" || QuantityDetermination["ObservedQuantityValue"] === "" || QuantityDetermination["BaseTemperatureValue"] === "") {
            let vali = validateField;
            vali["textstyle"] = "newerrortext";
            vali["msg"] = "Fields is Required !";
            setValidateField({ ...validateField, ...vali });

            if (QuantityDetermination["ObservedGravityValue"] === "") {
                let update = validateFieldClass;
                update["ObservedGravityValue"] = false;
                setValidateFieldClass({ ...validateFieldClass, ...update });
            }
            if (QuantityDetermination["ObservedGravityTemperature"] === "") {
                let update = validateFieldClass;
                update["ObservedGravityTemperature"] = false;
                setValidateFieldClass({ ...validateFieldClass, ...update });
            }
            if (QuantityDetermination["ObservedQuantityValue"] === "") {
                let update = validateFieldClass;
                update["ObservedQuantityValue"] = false;
                setValidateFieldClass({ ...validateFieldClass, ...update });
            }
            if (QuantityDetermination["ObservedQuantityTemperature"] === "") {
                let update = validateFieldClass;
                update["ObservedQuantityTemperature"] = false;
                setValidateFieldClass({ ...validateFieldClass, ...update });
            }
            if (QuantityDetermination["BaseTemperatureValue"] === "") {
                let update = validateFieldClass;
                update["BaseTemperatureValue"] = false;
                setValidateFieldClass({ ...validateFieldClass, ...update });
            }
        } else {
            let vali = validateField;
            vali["textstyle"] = "userinfo";
            vali["msg"] = "";
            setValidateField({ ...validateField, ...vali });

            switch (QuantityDetermination.Commodity) {
                case 1:
                    switch (QuantityDetermination.ObservedGravityType) {
                        case 1:
                            if (QuantityDetermination.ObservedGravityValue >= 611.5 && QuantityDetermination.ObservedGravityValue <= 1163) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Density must have a value between 611.5 and 1163";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature  in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 3:
                            if (QuantityDetermination.ObservedGravityValue >= -10 && QuantityDetermination.ObservedGravityValue <= 100) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "API Gravity must have a value between -10 and 100";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 2:
                            if (QuantityDetermination.ObservedGravityValue >= 0.6115 && QuantityDetermination.ObservedGravityValue <= 1.164) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Specific Gravity must have a value between 0.6115 and 1.164";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                    }

                case 2:
                    switch (QuantityDetermination.ObservedGravityType) {
                        case 1:
                            if (QuantityDetermination.ObservedGravityValue >= 611.5 && QuantityDetermination.ObservedGravityValue <= 1163) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Density must have a value between 611.5 and 1163";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature  in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 3:
                            if (QuantityDetermination.ObservedGravityValue >= -10 && QuantityDetermination.ObservedGravityValue <= 100) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "API Gravity must have a value between -10 and 100";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 2:
                            if (QuantityDetermination.ObservedGravityValue >= 0.6115 && QuantityDetermination.ObservedGravityValue <= 1.164) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Specific Gravity must have a value between 0.6115 and 1.164";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                    }
                    break;
                case 3:
                    switch (QuantityDetermination.ObservedGravityType) {
                        case 1:
                            if (QuantityDetermination.ObservedGravityValue >= 801.3 && QuantityDetermination.ObservedGravityValue <= 1163) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Density must have a value between 801.3 and 1163";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature  in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 3:
                            if (QuantityDetermination.ObservedGravityValue >= -10 && QuantityDetermination.ObservedGravityValue <= 45) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "API Gravity must have a value between -10 and 45";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                        case 2:
                            if (QuantityDetermination.ObservedGravityValue >= 0.8017 && QuantityDetermination.ObservedGravityValue <= 1.164) {
                                let update = error;
                                update["errormsg"] = "";
                                setError({ ...error, ...update });
                            } else {
                                let update = error;
                                update["errormsg"] = "Specific Gravity must have a value between 0.8017 and 1.164";
                                update["style"] = "newerrortext";
                                setError({ ...error, ...update });
                                break;
                            }

                            if (QuantityDetermination.ObservedGravityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedGravityTemperature !== "" && QuantityDetermination.ObservedGravityTemperature >= -50 && QuantityDetermination.ObservedGravityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }

                            } else if (QuantityDetermination.ObservedGravityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedGravityTemperature >= -58 && QuantityDetermination.ObservedGravityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }

                            if (QuantityDetermination.ObservedQuantityTemperatureUnit === 1) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -50 && QuantityDetermination.ObservedQuantityTemperature <= 150) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 C must have a value between -50 and 150 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            } else if (QuantityDetermination.ObservedQuantityTemperatureUnit === 2) {
                                if (QuantityDetermination.ObservedQuantityTemperature >= -58 && QuantityDetermination.ObservedQuantityTemperature <= 302) {
                                    let update = error;
                                    update["errormsg"] = "";
                                    setError({ ...error, ...update });
                                } else {
                                    let update = error;
                                    update["errormsg"] = " Quantity Temperature in \u00B0 F must have a value between -58 and 302 ";
                                    update["style"] = "newerrortext";
                                    setError({ ...error, ...update });
                                    break;
                                }
                            }
                            break;
                    }


            }
            if (QuantityDetermination.ObservedQuantityValue <= 0) {
                let update = error;
                update["errormsg"] = " Quantity must be a positive numeric value.";
                update["style"] = "newerrortext";
                setError({ ...error, ...update });
            }
            if (error.errormsg === "") {
                if (QuantityDetermination.BaseTemperatureUnit == 1) {
                    if (QuantityDetermination.BaseTemperatureValue >= -50 && QuantityDetermination.BaseTemperatureValue <= 150) {
                        let update = error;
                        update["errormsg"] = "";
                        setError({ ...error, ...update });
                    } else {
                        let update = error;
                        update["errormsg"] = " Temperature in \u00B0 C must have a value between -50 and 150.";
                        update["style"] = "newerrortext";
                        setError({ ...error, ...update });
                    }
                } else if (QuantityDetermination.BaseTemperatureUnit == 2) {
                    if (QuantityDetermination.BaseTemperatureValue >= -58 && QuantityDetermination.BaseTemperatureValue <= 302) {
                        let update = error;
                        update["errormsg"] = "";
                        setError({ ...error, ...update });
                    } else {
                        let update = error;
                        update["errormsg"] = " Temperature in \u00B0 F must have a value between -58 and 302.";
                        update["style"] = "newerrortext";
                        setError({ ...error, ...update });
                    }
                }
            }
            if (error.errormsg === "") {
                if (QuantityDetermination.BasePressureUnit == 1) {
                    if (QuantityDetermination.BasePressureValue >= 0 && QuantityDetermination.BasePressureValue <= 10342) {
                        let update = error;
                        update["errormsg"] = "";
                        setError({ ...error, ...update });
                    } else {
                        let update = error;
                        update["errormsg"] = " Pressure in KPa must have a value between 0 and 10342.";
                        update["style"] = "newerrortext";
                        setError({ ...error, ...update });
                    }
                } else if (QuantityDetermination.BasePressureUnit == 2) {
                    if (QuantityDetermination.BasePressureValue >= 0 && QuantityDetermination.BasePressureValue <= 103.4) {
                        let update = error;
                        update["errormsg"] = "";
                        setError({ ...error, ...update });
                    } else {
                        let update = error;
                        update["errormsg"] = " Pressure in Bar must have a value between 0 and 103.4.";
                        update["style"] = "newerrortext";
                        setError({ ...error, ...update });
                    }
                } else if (QuantityDetermination.BasePressureUnit == 3) {
                    if (QuantityDetermination.BasePressureValue >= 0 && QuantityDetermination.BasePressureValue <= 1500) {
                        let update = error;
                        update["errormsg"] = "";
                        setError({ ...error, ...update });
                    } else {
                        let update = error;
                        update["errormsg"] = " Pressure in Psi must have a value between 0 and 1500.";
                        update["style"] = "newerrortext";
                        setError({ ...error, ...update });
                    }
                }
            }
        }//else end--------

        if (error.errormsg === "") {
            let result = QuantityDeterminationService.QuantityDetermination(
                QuantityDetermination,
                close,
                close1
            )
            setOrder({ ...order, ...result });
            setFieldClass(false);
        }
    }
    const onValuesChange = (value, field) => {
        
        let local = QuantityDetermination;
        local[field] = value;
        setQuantityDetermination({ ...QuantityDetermination, ...local });
        setOrder({
            ...order, ...{
                CorrectedVolumeTextBox: "",
                VCFTextbox: "",
                WCFTextBox: "",
                WeightTextBox: "",
                MassLabel: ""
            }
        });
        if (QuantityDetermination["ObservedGravityValue"] !== "") {
            let update = validateFieldClass;
            update["ObservedGravityValue"] = true;
            setValidateFieldClass({ ...validateFieldClass, ...update });
        }
        if (QuantityDetermination["ObservedGravityTemperature"] !== "") {
            let update = validateFieldClass;
            update["ObservedGravityTemperature"] = true;
            setValidateFieldClass({ ...validateFieldClass, ...update });
        }
        if (QuantityDetermination["ObservedQuantityValue"] !== "") {
            let update = validateFieldClass;
            update["ObservedQuantityValue"] = true;
            setValidateFieldClass({ ...validateFieldClass, ...update });
        }
        if (QuantityDetermination["ObservedQuantityTemperature"] !== "") {
            let update = validateFieldClass;
            update["ObservedQuantityTemperature"] = true;
            setValidateFieldClass({ ...validateFieldClass, ...update });
        }
        if (QuantityDetermination["BaseTemperatureValue"] !== "") {
            let update = validateFieldClass;
            update["BaseTemperatureValue"] = true;
            setValidateFieldClass({ ...validateFieldClass, ...update });
        }

        switch (field) {
            case "ObservedGravityType": {
                if (value == 1) {
                    setQuantityDetermination({
                        ...QuantityDetermination, ...{
                            ObservedGravityType: value,
                            ObservedGravityTemperature: '15',
                            ObservedGravityTemperatureUnit: 1,
                        }
                    });
                }
                else {
                    setQuantityDetermination({
                        ...QuantityDetermination, ...{
                            ObservedGravityType: value,
                            ObservedGravityTemperature: '60',
                            ObservedGravityTemperatureUnit: 2,
                        }
                    });
                }
            } break;
            case "ObservedQuantityUnit": {
                if (value == 1) {
                    setQuantityDetermination({
                        ...QuantityDetermination, ...{
                            ObservedQuantityUnit: value,
                            ObservedQuantityTemperatureUnit: 1,
                        }
                    });
                }
                else {
                    setQuantityDetermination({
                        ...QuantityDetermination, ...{
                            ObservedQuantityUnit: value,
                            ObservedQuantityTemperatureUnit: 2,
                        }
                    });
                }
            } break;
        }
    }
    const handleChange = (check) => {
        setClose(check)
    }
    const handleChangeon = (check1) => {
        setClose1(check1)
    }

    const gravityUnitValue = (val) => {
        if (val == "1") {
            return "Dens.";
        } else if (val == "2") {
            return "S.G.";
        } else if (val == "3") {
            return "API";
        } else {
            return '';
        }
    }
    const gravitytemp = (val) => {
        if (val == 1) {
            return "\u00B0 C";
        } else if (val == 2) {
            return "\u00B0 F";
        } else {
            return '';
        }
    }
    const gravitypress = (val) => {
        if (val == 1) {
            return "KPa";
        } else if (val == 2) {
            return "Bar";
        } else if (val == 3) {
            return "Psi";
        } else {
            return '';
        }
    }
    const quantityunitValue = (val) => {
        if (val == "1") {
            return "m3";
        } else if (val == "2") {
            return "bbl";
        } else if (val == "3") {
            return "usg";
        } else {
            return '';
        }
    }
    const quantitytemp = (val) => {
        if (val == 1) {
            return "\u00B0 C";
        } else if (val == 2) {
            return "\u00B0 F";
        }
    }
    const quantitypress = (val) => {
        if (val == 1) {
            return "KPa";
        } else if (val == 2) {
            return "Bar";
        } else if (val == 3) {
            return "Psi";
        } else {
            return '';
        }
    }

    const generateGrid = (mode) => {
        
        let dataAdd = {
            gravity: QuantityDetermination.ObservedGravityValue,
            gunit: gravityUnitValue(QuantityDetermination.ObservedGravityType),
            gtemp: QuantityDetermination.ObservedGravityTemperature + gravitytemp(QuantityDetermination.ObservedGravityTemperatureUnit),
            gpress: QuantityDetermination.ObservedGravityPressure + gravitypress(QuantityDetermination.ObservedGravityPressureUnit),
            obsvolume: QuantityDetermination.ObservedQuantityValue,
            qunit: quantityunitValue(QuantityDetermination.ObservedQuantityUnit),
            qtemp: QuantityDetermination.ObservedQuantityTemperature + quantitytemp(QuantityDetermination.ObservedQuantityTemperatureUnit),
            qpress: QuantityDetermination.ObservedQuantityPressure + quantitypress(QuantityDetermination.ObservedQuantityPressureUnit),
            VCF: order.VCFTextbox,
            Corr_Vol_m3: order.CorrectedVolumeTextBox,
            Weight_MT: order.WeightTextBox

        };
        let dataSub = {
            gravity: QuantityDetermination.ObservedGravityValue,
            gunit: gravityUnitValue(QuantityDetermination.ObservedGravityType),
            gtemp: QuantityDetermination.ObservedGravityTemperature + gravitytemp(QuantityDetermination.ObservedGravityTemperatureUnit),
            gpress: QuantityDetermination.ObservedGravityPressure + gravitypress(QuantityDetermination.ObservedGravityPressureUnit),
            obsvolume: QuantityDetermination.ObservedQuantityValue,
            qunit: quantityunitValue(QuantityDetermination.ObservedQuantityUnit),
            qtemp: QuantityDetermination.ObservedQuantityTemperature + quantitytemp(QuantityDetermination.ObservedQuantityTemperatureUnit),
            qpress: QuantityDetermination.ObservedQuantityPressure + quantitypress(QuantityDetermination.ObservedQuantityPressureUnit),
            VCF: order.VCFTextbox,
            Corr_Vol_m3: -order.CorrectedVolumeTextBox,
            Weight_MT: -order.WeightTextBox
        };


        let gridVal = gridData;
        if (mode == 'sub') {
            let volume = 0;
            let weight = 0;
            gridData.push(dataSub);
            gridData.forEach((val, index) => {
                ;
                volume += Number(val.Corr_Vol_m3);
                weight += Number(val.Weight_MT);
            });
            setGridData([...gridVal]);
            setAdd({ ...add, ...{ volume: parseFloat(volume.toFixed(3)), weight: parseFloat(weight.toFixed(3)) } });
            setAsclose(true);
            setClose(true);
            setDisableInput(true);
        } else if (mode == 'add') {
            let volume = 0;
            let weight = 0;
            gridData.push(dataAdd);
            gridData.forEach((val, index) => {
                ;
                volume += Number(val.Corr_Vol_m3);
                weight += Number(val.Weight_MT);
            });
            setGridData([...gridVal]);
            setAdd({ ...add, ...{ volume: parseFloat(volume.toFixed(3)), weight: parseFloat(weight.toFixed(3)) } });
            setAsclose(true);
            setClose(true);
            setDisableInput(true);
        }
    }
    const handleRemove = (index) => {
        
        let filterTable = gridData.filter((ele, idx) => index != idx);
        //console.log(filterTable);
        setGridData([...filterTable]);
    }

    const total = () => {
        let volume = 0;
        let weight = 0;
        gridData.forEach((val, index) => {
            ;
            volume += Number(val.Corr_Vol_m3);
            weight += Number(val.Weight_MT);
        });
        setAdd({ ...add, ...{ volume: parseFloat(volume.toFixed(3)), weight: parseFloat(weight.toFixed(3)) } });
    }

    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>QuantityDetermination</span>

                </div>
                <span className={error.style}>{error.errormsg}</span>
                <span className={validateField.textstyle}>{validateField.msg}</span>
                <Box component="div" className="filtercontainer">
                    <Box component="div" className="bunkarinput">
                        <Box component="div" className="pos_relative">
                            <Box component="div" className="help_blk">
                                <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    scroll={scroll}
                                    aria-labelledby="scroll-dialog-title"
                                    aria-describedby="scroll-dialog-description"
                                >
                                    <DialogTitle id="scroll-dialog-title">Quantity Determination</DialogTitle>
                                    <DialogContent dividers={scroll === 'paper'}>
                                        <DialogContentText
                                            id="scroll-dialog-description"
                                            ref={descriptionElementRef}
                                            tabIndex={-1}
                                        >
                                            <p>This module performs standard Quantity Calculations. The Correction Factor for Temperature and Pressure (CTPL or VCF) is calculated using the method specified in ASTM D 1250-04 and expressed with 5 decimal figures. Volume to weight conversions is performed by converting volumes to cubic meters @ 15°C and gravities to density @ 15°C. A weight factor is than determined in conformance with ASTM D 1250-80 Table 56 to obtain a weight in Metric Tons. Precision as expressed in number of decimal places can be set in the Properties module.

                                            </p>
                                            <p>For atmospheric pressure, enter zero in the pressure field or leave the field blank. For standard barge or ship tank measurements, pressure correction is not required. Applying Pressure Correction is switched off by default in Bunker Master. The calculations are then similar to the old 1980 tables.</p>
                                            <p className="subtitle">Example</p>

                                            <img className="maxwidth100" src="/assets/images/Quantity-Determination-1.jpg"></img>
                                            <img className="maxwidth100" src="/assets/images/Quantity-Determination-2.jpg"></img>

                                            <p>For each tank enter the gravity, gravity temperature (and pressure), volume, volume temperature (and pressure) then press the Calcuate button. Then, depending on the calculation, press either the Add or Subtract button to add the data to the grid.

                                            </p>
                                            <p>For R.O.B. totals use the Add button to calculate the total quantity. For barge outturn calculations use the Add button for opening readings and the Subtract button for closing readings to obtain a total delivered quantity. You can use the Total button to recalculate the total volume and weight.

                                            </p>
                                            <p>When manually adding or removing rows with data you must use the Total button to calculate the total volume and weight.

                                            </p>
                                            <p>Certain default settings can be set in the properties module. When you open the quantity module, you can set base values and default settings like commodity, base temperature and volume unit for that particular calculation. However once a row has been added to the grid, these settings can no longer be changed, unless all data is cleared from the grid.

                                            </p>

                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose}>Close</Button>
                                    </DialogActions>
                                </Dialog>
                            </Box>
                        </Box>

                        <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl}>
                            <Grid container spacing={3}  >
                                <Grid item xs={12} md={7}>
                                    <p className="subtitle mt25 padbtm25">Observed Gravity</p>
                                    <Select labelId="outlined-label3" className="mr20 bunkerselect bigbox1"
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedGravityType")}
                                        value={QuantityDetermination.ObservedGravityType}
                                    >
                                        <MenuItem value={1}>Density, Kg/m3</MenuItem>
                                        <MenuItem value={3}>API Gravity,  <sup>o</sup>API</MenuItem>
                                        <MenuItem value={2}>Specific Gravity</MenuItem>
                                    </Select>

                                    <BootstrapInput type="number"
                                        className={validateFieldClass.ObservedGravityValue ? "mt0" : "error"}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedGravityValue")}

                                    />

                                    at   <BootstrapInput type="number"
                                        className={validateFieldClass.ObservedGravityTemperature ? "mr20 smallbox" : "error smallbox"}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedGravityTemperature")}
                                        value={QuantityDetermination.ObservedGravityTemperature}
                                    />
                                    <Select labelId="outlined-label4" className="mr20 bunkerselect smallbox"
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedGravityTemperatureUnit")}
                                        value={QuantityDetermination.ObservedGravityTemperatureUnit}
                                    >
                                        <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                        <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                    </Select>
                                    <span> and </span>
                                    <BootstrapInput type="number" className="mr20  smallbox" disabled={close}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedGravityPressure")}
                                        value={QuantityDetermination.ObservedGravityPressure}
                                    />
                                    <Select labelId="outlined-label5" className="mr20 bunkerselect  smallbox" disabled={close}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedGravityPressureUnit")}
                                        value={QuantityDetermination.ObservedGravityPressureUnit}
                                    >
                                        <MenuItem value={1}>kPa</MenuItem>
                                        <MenuItem value={2}>Bar</MenuItem>
                                        <MenuItem value={3}>Psi</MenuItem>
                                    </Select>
                                    {/* <span className="errortext padb15  mt5"> Density is required.</span> */}

                                    <Select labelId="outlined-label6" className="mr20 bunkerselect bigbox1 mt25"
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedQuantityUnit")}
                                        value={QuantityDetermination.ObservedQuantityUnit}
                                    >
                                        <MenuItem value={1}>Measured Volume, m3</MenuItem>
                                        <MenuItem value={2}>Measured Volume, bbl</MenuItem>
                                        <MenuItem value={3}>Measured Volume, usg</MenuItem>
                                    </Select>

                                    <BootstrapInput type="number"
                                        className={validateFieldClass.ObservedQuantityValue ? "mt0" : "error"}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedQuantityValue")}
                                    />

                                    at   <BootstrapInput type="number"
                                        //className="mr20 smallbox"
                                        className={validateFieldClass.ObservedQuantityTemperature ? "mr20 smallbox" : "error smallbox"}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedQuantityTemperature")}

                                    />
                                    <Select labelId="outlined-label7" className="mr20 bunkerselect smallbox"
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedQuantityTemperatureUnit")}
                                        value={QuantityDetermination.ObservedQuantityTemperatureUnit}
                                    >
                                        <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                        <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                    </Select>
                                    <span> and </span>
                                    <BootstrapInput type="number" className="mr20  smallbox" disabled={close}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedQuantityPressure")}
                                        value={QuantityDetermination.ObservedQuantityPressure}
                                    />
                                    <Select labelId="outlined-label8" className="mr20 bunkerselect  smallbox" disabled={close}
                                        onChange={(e) => onValuesChange(e.target.value, "ObservedQuantityPressureUnit")}
                                        value={QuantityDetermination.ObservedQuantityPressureUnit}
                                    >
                                        <MenuItem value={1}>kPa</MenuItem>
                                        <MenuItem value={2}>Bar</MenuItem>
                                        <MenuItem value={3}>Psi</MenuItem>

                                    </Select>
                                    {/* <span className="errortext   mt5 padb15"> Measured is required.</span> */}
                                    <Box component="div" className="resultbox mt25" >
                                        <p>Base Values & Default Settings </p>
                                        <Box component="div" className="bunkarinput  mar25">

                                            <form className={classes.root} noValidate autoComplete="off">

                                                <Box component="div" className="">
                                                    <label className=" widthauto">Commodity</label>

                                                    <Select labelId="outlined-label9" className="mr20 bunkerselect bigbox1  " disabled={Asclose}
                                                        onChange={(e) => onValuesChange(e.target.value, "Commodity")}
                                                        value={QuantityDetermination.Commodity}
                                                    >
                                                        <MenuItem value={1}>Crude Oil</MenuItem>
                                                        <MenuItem value={2}>Refined Products</MenuItem>
                                                        <MenuItem value={3}>Lubricating Oil</MenuItem>
                                                    </Select>
                                                </Box>
                                                <Box component="div" className=""  >
                                                    <label className="widthauto ">Temperature</label>
                                                    <BootstrapInput type="number" disabled={Asclose}
                                                        className={validateFieldClass.BaseTemperatureValue ? "mr20 smallbox" : "error smallbox"}
                                                        onChange={(e) => onValuesChange(e.target.value, "BaseTemperatureValue")}
                                                        value={QuantityDetermination.BaseTemperatureValue}
                                                    />
                                                    <Select labelId="outlined-label1" className="mr20 bunkerselect smallbox  " disabled={Asclose}
                                                        onChange={(e) => onValuesChange(e.target.value, "BaseTemperatureUnit")}
                                                        value={QuantityDetermination.BaseTemperatureUnit}
                                                    >
                                                        <MenuItem value={1}> <sup>o</sup>C</MenuItem>
                                                        <MenuItem value={2}> <sup>o</sup>F</MenuItem>
                                                    </Select>
                                                </Box>
                                                <Box component="div" className="">
                                                    <label className=" widthauto">Pressure</label>
                                                    <BootstrapInput type="number" className="mr20 smallbox" disabled={close}
                                                        onChange={(e) => onValuesChange(e.target.value, "BasePressureValue")}
                                                        value={QuantityDetermination.BasePressureValue}
                                                    />
                                                    <Select labelId="outlined-label2" className="mr20 bunkerselect smallbox" disabled={close}
                                                        onChange={(e) => onValuesChange(e.target.value, "BasePressureUnit")}
                                                        value={QuantityDetermination.BasePressureUnit}
                                                    >
                                                        <MenuItem value={1}>kPa</MenuItem>
                                                        <MenuItem value={2}>Bar</MenuItem>
                                                        <MenuItem value={3}>Psi</MenuItem>

                                                    </Select>

                                                </Box>

                                                <Box component="div" className="mt10">
                                                    <PressureCorrection onChange={handleChange} disableSlider={disableInput} />

                                                </Box>


                                                <FormControl component="fieldset" className="disblock">
                                                    <RadioGroup row aria-label="position" name="position" defaultValue="top">
                                                        <label className="pr30 widthauto "> Corrected Volume in   </label>
                                                        <Determination_Switches onChange={handleChangeon} disableSlider={disableInput} />


                                                    </RadioGroup>
                                                </FormControl>



                                            </form>
                                        </Box>
                                    </Box>
                                    <br></br>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={12} className="mb25  pt20 mt25">
                                            <button type="button" className={classes.btn1} onClick={() => generateGrid('sub')}>Subtract</button>{''}
                                            <button type="reset" className={classes.btn2} onClick={() => generateGrid('add')}>Add</button>
                                            <button type="reset" className={classes.btn2} onClick={CalculateQuantityDetermination} >Calculate</button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={5} >
                                    <br /> <br /><br />
                                    <Box component="div" className="resultbox mt25">
                                        <p>Results</p>
                                        <Box component="div" className="bunkarinput resultinner">

                                            <form className={classes.root} noValidate autoComplete="off">
                                                <Box component="div" className="padbtm25">
                                                    <label className="resultLabel">Volume Correction Factor </label>
                                                    <TextField id="standard-basic" value={order.VCFTextbox} />
                                                    {/* <label className=" ">Volume Correction Factor</label>
                                                    <BootstrapInput type="number" className="mr20 disableinput" disabled
                                                        value={order.VCFTextbox}
                                                    /> */}
                                                </Box>
                                                <Box component="div" className="padbtm25">
                                                    <label className="resultLabel">Volume to Weight Factor</label>
                                                    <TextField id="standard-basic" value={order.WCFTextBox} />
                                                    {/* <label className="widthauto ">Volume to Weight Factor</label>
                                                    <BootstrapInput type="number" className="mr20  disableinput" disabled
                                                        value={order.WCFTextBox}
                                                    /> */}
                                                </Box>
                                                <Box component="div" className="padbtm25">
                                                    <label className="resultLabel">Corrected Base Volume,{close1 == true ? "m3" : "bbl"}</label>
                                                    <TextField id="standard-basic" value={order.CorrectedVolumeTextBox} />
                                                    {/* <label className=" ">Corrected Base Volume,{close1 == true ? "m3" : "bbl"}</label>
                                                    <BootstrapInput type="number" className="mr20  disableinput" disabled
                                                        value={order.CorrectedVolumeTextBox}
                                                    /> */}
                                                </Box>
                                                <Box component="div" className="padbtm25">
                                                    <label className="resultLabel">Quantity as Weight in MT</label>
                                                    <TextField id="standard-basic" value={order.WeightTextBox} />
                                                    {/* <label className=" widthauto ">Quantity as Weight in MT</label>
                                                    <BootstrapInput type="number" className="mr20  disableinput" disabled
                                                        value={order.WeightTextBox}
                                                    /> */}
                                                </Box>

                                                <Box component="div" className="padbtm25">
                                                    <span className={fieldClass ? "userinfo" : "resultin"}>For info only-Mass,MT:{order.MassLabel}</span>
                                                </Box>
                                            </form>
                                        </Box>
                                    </Box>

                                </Grid>
                                <Grid item xs={12} md={12}>

                                    <TableContainer component={Paper}  >
                                        <Table className={classes.table} aria-label="customized table">
                                            <TableHead>
                                                <TableRow >
                                                    <StyledTableCell>Tank No.</StyledTableCell>
                                                    <StyledTableCell >Gravity</StyledTableCell>
                                                    <StyledTableCell >Unit</StyledTableCell>
                                                    <StyledTableCell >Temp.</StyledTableCell>
                                                    <StyledTableCell style={{ display: close === true ? 'none' : 'block' }}>press.</StyledTableCell>
                                                    <StyledTableCell >Obs. Volume</StyledTableCell>
                                                    <StyledTableCell >Unit</StyledTableCell>
                                                    <StyledTableCell >Temp.</StyledTableCell>
                                                    <StyledTableCell style={{ display: close === true ? 'none' : 'block' }}>press.</StyledTableCell>
                                                    <StyledTableCell >VCF</StyledTableCell>
                                                    <StyledTableCell >Corr. Vol., {close1 == true ? "m3" : "bbl"}</StyledTableCell>
                                                    <StyledTableCell >Weight , MT</StyledTableCell>
                                                    <StyledTableCell >Delete</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {gridData.length > 0 && gridData.map((row, idx) => (
                                                    <StyledTableRow key={idx}>
                                                        <StyledTableCell  >{row.idx}</StyledTableCell>
                                                        <StyledTableCell  >{row.gravity}</StyledTableCell>
                                                        <StyledTableCell  >{row.gunit}</StyledTableCell>
                                                        <StyledTableCell  >{row.gtemp}</StyledTableCell>
                                                        <StyledTableCell style={{ display: close === true ? 'none' : 'block' }}>{row.gpress}</StyledTableCell>
                                                        <StyledTableCell  >{row.obsvolume}</StyledTableCell>
                                                        <StyledTableCell  >{row.qunit}</StyledTableCell>
                                                        <StyledTableCell  >{row.qtemp}</StyledTableCell>
                                                        <StyledTableCell style={{ display: close === true ? 'none' : 'block' }}>{row.qpress}</StyledTableCell>
                                                        <StyledTableCell  >{row.VCF}</StyledTableCell>
                                                        <StyledTableCell style={{ color: row.Corr_Vol_m3 > 0 ? "black" : "red" }}>{row.Corr_Vol_m3}</StyledTableCell>
                                                        <StyledTableCell style={{ color: row.Weight_MT > 0 ? "black" : "red" }}>{row.Weight_MT}</StyledTableCell>
                                                        <StyledTableCell >
                                                            <IconButton aria-label="delete">
                                                                <DeleteIcon onClick={() =>
                                                                    handleRemove(idx)
                                                                } />
                                                            </IconButton>
                                                        </StyledTableCell>
                                                        {/* {alert("✔️ This works on every component!");} */}

                                                    </StyledTableRow>

                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <p className="subtitle mt25 ">Quantity Total  </p>
                                    <label className="widthauto" >Volume, m3</label>
                                    <BootstrapInput type="number" className="mr20 " style={{ color: add.volume >= 0 ? "black" : "red" }}
                                        value={add.volume}
                                    />
                                    {/* <TextField id="standard-basic" className=" mr20 padbtm25" style={{ color: add.volume >= 0 ? "black" : "red" }}
                                     value={add.volume}
                                    /> */}
                                    <label className="widthauto" >Weight, MT</label>
                                    <BootstrapInput type="number" className="mr20  padbtm25" style={{ color: add.weight >= 0 ? "black" : "red" }}
                                        value={add.weight}
                                    />
                                    {/* <TextField id="standard-basic" className=" mr20 padbtm25"  style={{ color: add.volume >= 0 ? "black" : "red" }}
                                     value={add.weight}
                                    /> */}

                                    <button type="button" className={classes.btn1} onClick={() => total()} >Total</button>





                                </Grid>

                            </Grid>




                        </FormControl>




                    </Box>








                </Box>








            </div>
        </div>
    );
}
export default QuantityDetermination;
